import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

function ConfirmSubmitDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
    >
      <DialogTitle id="confirm-dialog-title">Confirm Submission</DialogTitle>
      <DialogContent>
        {"Are you sure you want to submit your application?"}
        <br />
        {"Once submitted, you won't be able to make changes."}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmSubmitDialog;
